import script from "./CustomDisclosure.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomDisclosure.vue?vue&type=script&lang=ts&setup=true"

import "./CustomDisclosure.vue?vue&type=style&index=0&id=7f4cf9b1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f4cf9b1"]])

export default __exports__